export default class TextUtils {
	static copyToClipboard(text: string) {
		//Source: https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
		const textArea = document.createElement("textarea");
		textArea.style.position = 'fixed';
		textArea.style.top = "-10px";
		textArea.style.left = "-10px";
		textArea.style.width = '2em';
		textArea.style.height = '2em';
		textArea.style.padding = "0px";
		textArea.style.border = 'none';
		textArea.style.outline = 'none';
		textArea.style.boxShadow = 'none';
		textArea.style.background = 'transparent';
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
		try {
			document.execCommand('copy');
		}
		catch (err) {
			console.error(err);
		}
		document.body.removeChild(textArea);
	}

	/**
	 * Replace links with html <a> tag.
	 * https://ctrlq.org/code/20294-regex-extract-links-javascript
	 * @param {string} text text to find links
	 * @returns {string} text with html <a> tag instead of links.
	 */
	static createTextLinks(text: string) {
		return (text || "").replace(
			/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi,
			(match: string, space: string, url: string) => {
				var hyperlink = url;
				if (!hyperlink.match('^https?:\/\/')) {
					hyperlink = 'http://' + hyperlink;
				}
				return space + '<a href="' + hyperlink + '" target="_blank" class="t-link">' + url + '</a>';
			}
		);
	};

	static textEllipsis(text: string, maxLength: number = 20) {
		return text.length > maxLength ? `${text.substr(0, maxLength)}...` : text
	}

	static addSIfPlural(text: string, count: number) {
		return `${text}${count !== 1 ? "s" : ""}`
	}
}